export default __webpack_public_path__ + "static/media/money_hand.b3272baa.svg";